<template>
  <div class="actions-collapsed-list">
    <a
      class="btn btn-function exit-collapsed-list"
      @click="collapseActions"
    >
      <i
        class="glyphicon glyphicon-chevron-left"
        aria-hidden="true"
        tooltip-placement="right"
        uib-tooltip="Cancel"
      />
    </a>

    <div class="action-icon">
      <a
        class="btn btn-list-function"
        @click="showForm"
      >
        <i
          v-tooltip.bottom.hover="$t('EDIT')"
          class="typcn typcn-edit"
          aria-hidden="true"
        />
        <span
          v-t="'EDIT'"
          class="hint-text-mobile"
        />
      </a>
    </div>
    <div class="action-icon">
      <a
        :disabled="disabled"
        class="btn btn-list-function"
        @click="displayDeleteModal"
      >
        <i
          v-tooltip.bottom.hover="$t('DELETE')"
          class="typcn typcn-trash"
          aria-hidden="true"
        />
        <span
          v-t="'DELETE'"
          class="hint-text-mobile"
        />
      </a>
    </div>
    <ChangeLogObjectButtonAction
      :is-disabled="disabled"
      :object-id="currentUrlParameter.id"
      :object-name="currentUrlParameter.incomingQueryStringName"
      object-type="URL parameter"
    />

    <ConfirmationModal 
      v-if="showDeleteModal"
      :title="$t('TITLE_DELETE')"
      :cancel-button-text="$t('CANCEL')"
      :confirm-action-text="$t('DELETE')"
      :confirm-button-disabled="pending || error"
      :confirm-button-loading="deleting"
      @confirm="confirmDeleteModal"
      @close="hideDeleteModal"
    >
      <div v-if="pending || error">
        <div>
          <Loader v-if="pending" />
          <span v-t="checkReferencesText" />
        </div>
      </div>

      <p
        v-if="!pending && !error && urlParamReferences && !urlParamReferences.hasReferences"
        v-t="'LABEL_DELETE_MODAL_MESSAGE_ASSOCIATION_EMPTY'"
      />

      <div v-if="!pending && urlParamReferences && urlParamReferences.hasReferences">
        <span v-html="$t('LABEL_DELETE_MODAL_MESSAGE_ASSOCIATION_LOADED', { name: currentUrlParameter.incomingQueryStringName })">
          <br>
        </span>

        <div class="well well-sm m-t-10 m-b-0">
          <div class="form-horizontal">
            <div
              v-if="urlParamReferences.campaigns && urlParamReferences.campaigns.length"
              class="row"
            >
              <label class="col-md-3 control-label">
                <strong v-t="'LABEL_DELETE_MODAL_CAMPAIGNS'" />
              </label>
              <div class="col-md-8">
                <ul class="list-unstyled form-control-static list-text-overflow">
                  <template v-for="campaign in urlParamReferences.campaigns">
                    <li :key="campaign.campaignId">
                      <a
                        v-tooltip.right="$t('TT_VIEW_CAMPAIGN')"
                        target="_blank"
                        href="javascript:;"
                        @click.prevent="goToCampaign(campaign.campaignId)"
                      >
                        <span
                          class="display-text"
                          :title="campaign.campaignName"
                        >
                          {{ campaign.campaignName }}
                        </span>
                        <i class="fa fa-external-link m-l-5" />
                      </a>
                    </li>
                  </template>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ConfirmationModal>
  </div>
</template>

<script>
import ConfirmationModal from '@/core/components/ConfirmationModal/ConfirmationModal';
import ChangeLogObjectButtonAction from '@/core/components/ChangeLog/ChangeLogObjectButtonAction';
import Loader from '@/core/components/Loader';
import messages from '../locales';
import sharedMessages from '@/core/locales';
import { $ngStateService, accountsService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { STATUS_PENDING, STATUS_ERROR } from '@/store/helpers';

export default {
  name: 'UsersActions',
  components: {
    ConfirmationModal,
    ChangeLogObjectButtonAction,
    Loader
  },
  props:{
    currentUrlParameter: {
      type: Object,
      default() {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    getReferencesStatus: {
      type: Object,
      default: function() {
        return {};
      }
    },
    deleteParameterStatus: {
      type: Object,
      default: function() {
        return {};
      }
    },
    urlParamReferences: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      showDeleteModal: false,
      showPopOver: false,
      placement: 'bottomleft'
    };
  },
  computed: {
    currentUserName() { return accountsService.currentUserName; },
    checkReferencesText() {
      if(this.pending) {
        return 'LABEL_DELETE_MODAL_MESSAGE_ASSOCIATION_LOADING';
      }
      if(this.error) {
        return 'LABEL_DELETE_MODAL_MESSAGE_ASSOCIATION_ERROR';
      }

      return '';
    },
    pending() { return this.getReferencesStatus.status == STATUS_PENDING; },
    error() { return this.getReferencesStatus.status == STATUS_ERROR; },
    deleting() { return this.deleteParameterStatus.status == STATUS_PENDING; }
  },
  methods:{
    togglePopover() {
      this.showPopOver = !this.showPopOver;
    },
    displayDeleteModal() {
      if (!this.disabled) {
        this.$emit('open-delete', this.currentUrlParameter.id);
        this.showDeleteModal = true;
      }
    },
    hideDeleteModal() {
      this.showDeleteModal = false;
      this.references = null;
    },
    confirmDeleteModal() {
      this.$emit('confirm-delete', this.currentUrlParameter.id);
    },    
    showForm() {
      this.$emit('edit', this.currentUrlParameter.id);
    },
    collapseActions() {
      this.$emit('collapse-actions', this.currentUrlParameter.id);
    },    
    goToCampaign(id) {
      var url = $ngStateService.href('dashboard.campaign', { campaignId: id});
      window.open(url,'_blank'); // Open new tab
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>

<style lang="scss">
form.user {
  .multi-select-lg {
    width: 100%;
  }

  .v-select .vs__selected {
    height: 32px;
    padding: 8px 8px 7px 10px;
    border-bottom: 1px solid transparent;
  }
}

.popover.left > .arrow:after {
  border-left-color: var(--component-in-app-notifications__popover)
}
</style>